var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendericon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6_634)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.9751 0.993774V2.98124",
    stroke: "#FDC700",
    strokeWidth: 0.993734,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.94971 0.993774V2.98124",
    stroke: "#FDC700",
    strokeWidth: 0.993734,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.4406 1.98743H2.48446C1.93563 1.98743 1.49072 2.43234 1.49072 2.98116V9.9373C1.49072 10.4861 1.93563 10.931 2.48446 10.931H9.4406C9.98942 10.931 10.4343 10.4861 10.4343 9.9373V2.98116C10.4343 2.43234 9.98942 1.98743 9.4406 1.98743Z",
    stroke: "#FDC700",
    strokeWidth: 0.993734,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.49072 4.96863H10.4343",
    stroke: "#FDC700",
    strokeWidth: 0.993734,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6_634"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.9248,
    height: 11.9248,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendericon);
export default __webpack_public_path__ + "static/media/calender icon.d306dbcdba197cbf9042337164092279.svg";
export { ForwardRef as ReactComponent };